import { IMPORT_OPTIONS_SUCCESS_TOAST_MESSAGE_KEY } from '@/features/transaction_items/Detail/components/Drawer/ImportTransactionDetailOptionDrawer/constant';
import { useToastAPI } from '@moneyforward/ap-frontend-components';
import { useEffect } from 'react';

export const useImportOptionsToast = (onTriggerRefetch: () => void) => {
  const notify = useToastAPI();

  useEffect(() => {
    const message = sessionStorage.getItem(
      IMPORT_OPTIONS_SUCCESS_TOAST_MESSAGE_KEY
    );
    if (!message) return;

    notify.pending({
      title: message,
    });
    sessionStorage.removeItem(IMPORT_OPTIONS_SUCCESS_TOAST_MESSAGE_KEY);
    onTriggerRefetch();
  }, [notify, onTriggerRefetch]);
};
